import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SignatureDebugLogs } from './SignatureDebugLogs';
import { PromptVersionManager } from './PromptVersionManager';
import { ExperimentalTesting } from './ExperimentalTesting';
import { Brain, Database, FlaskConical } from 'lucide-react';

export function AIPromptsManager() {
  return (
    <Tabs defaultValue="extraction-logs" className="space-y-6">
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="extraction-logs" className="gap-2">
          <Database className="h-4 w-4" />
          <span className="hidden sm:inline">Extraction Logs</span>
          <span className="sm:hidden">Logs</span>
        </TabsTrigger>
        <TabsTrigger value="prompt-versions" className="gap-2">
          <Brain className="h-4 w-4" />
          <span className="hidden sm:inline">Prompt Versions</span>
          <span className="sm:hidden">Prompts</span>
        </TabsTrigger>
        <TabsTrigger value="testing" className="gap-2">
          <FlaskConical className="h-4 w-4" />
          <span className="hidden sm:inline">Testing</span>
          <span className="sm:hidden">Test</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="extraction-logs">
        <SignatureDebugLogs />
      </TabsContent>
      
      <TabsContent value="prompt-versions">
        <PromptVersionManager />
      </TabsContent>
      
      <TabsContent value="testing">
        <ExperimentalTesting />
      </TabsContent>
    </Tabs>
  );
}
